import EcodopplerArtiInferioriEdit from "./components/EcodopplerArtiInferioriEdit.vue";
import EcodopplerArtiInferioriView from "./components/EcodopplerArtiInferioriView.vue";
import EcodopplerArtiInferioriList from "./components/EcodopplerArtiInferioriList.vue";

export default {
    EcodopplerArtiInferioriEdit,
    EcodopplerArtiInferioriView,
    EcodopplerArtiInferioriList,
};
